
// Get All Bagages
export const getBagagesStart = ()=>({
    type: 'GET_BAGAGES_START',
})
export const getBagagesSuccess = (bagages)=>({
    type: 'GET_BAGAGES_SUCCESS',
    payload: bagages
})
export const getBagagesFailure = (error)=>({
    type: 'GET_BAGAGES_FAILURE',
    payload: error
})